/* Aerotex product comparison: tick "Compare" on up to 4 products (across any product page), then see them side by side */
(function () {
  'use strict';
  var root = document.querySelector('[data-ax-library]');
  if (!root) return;
  var RAW = [];
  try { RAW = JSON.parse(root.querySelector('[data-ax-lib-data]').textContent); } catch (e) { return; }
  var P = [], seen = {};
  RAW.forEach(function (p) {
    if (seen[p.h]) { if (seen[p.h].types.indexOf(p.y) < 0) seen[p.h].types.push(p.y); return; }
    p.types = [p.y]; seen[p.h] = p; P.push(p);
  });
  var SWATCH = ['aerotex-fabric', 'aerotex-premium-fabric', 'luxaire-fabric-duralite', 'aircraft-leather', 'aircraft-vinyl', 'coin-dot-flooring', 'wall-blanket-insulation', 'boltatron-4335', 'kydex-100', 'kydex-t'];
  var KEY = 'aerotex-compare', MAX = 4;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var snap = function (p) { return { h: p.h, t: p.t, u: p.u, i: p.i, c: p.c, types: p.types, s: p.s, vc: p.vc, a: p.a, d: p.d, v: p.v.slice(0, 40).map(function (v) { return { t: v.t, s: v.s, i: v.i || '' }; }) }; };
  var sel = [];
  try { sel = JSON.parse(sessionStorage.getItem(KEY) || '[]').filter(function (x) { return x && x.h; }).slice(0, MAX); } catch (e) {}
  sel = sel.map(function (x) { return seen[x.h] ? snap(seen[x.h]) : x; });
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(sel)); } catch (e) {} }
  var has = function (h) { return sel.some(function (x) { return x.h === h; }); };

  /* ---------- Compare toggle on every tile ---------- */
  var cards = [].slice.call(root.querySelectorAll('[data-ax-lib-i]'));
  cards.forEach(function (li) {
    var p = P[li.dataset.axLibI]; if (!p) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ax-cmp__tog'; b.dataset.axCmp = p.h;
    b.innerHTML = '<span aria-hidden="true"></span>Compare';
    li.appendChild(b);
  });

  /* ---------- Tray ---------- */
  var tray = root.querySelector('[data-ax-cmp-tray]'), list = root.querySelector('[data-ax-cmp-list]'), go = root.querySelector('[data-ax-cmp-go]'), msg = root.querySelector('[data-ax-cmp-msg]');
  var dlg = root.querySelector('[data-ax-cmp-dialog]'), table = root.querySelector('[data-ax-cmp-table]');
  function render() {
    root.querySelectorAll('[data-ax-cmp]').forEach(function (b) {
      var on = has(b.dataset.axCmp);
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      b.disabled = !on && sel.length >= MAX;
      b.title = b.disabled ? 'You can compare up to ' + MAX + ' products' : '';
    });
    tray.hidden = !sel.length;
    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var p = sel[i];
      slots += p ? '<li><img src="' + esc(p.i) + '" alt=""><span>' + esc(p.t) + '</span><button type="button" data-ax-cmp-rm="' + esc(p.h) + '" aria-label="Remove ' + esc(p.t) + ' from comparison">×</button></li>' : '<li class="is-empty"><span>Add a product</span></li>';
    }
    list.innerHTML = slots;
    go.disabled = sel.length < 2;
    go.textContent = 'Compare ' + (sel.length > 1 ? sel.length + ' products' : '');
    msg.textContent = sel.length < 2 ? 'Pick at least 2 products to compare' : sel.length + ' of ' + MAX + ' selected';
    document.body.classList.toggle('ax-cmp-open', !!sel.length);
  }
  function toggle(h) {
    if (has(h)) sel = sel.filter(function (x) { return x.h !== h; });
    else if (sel.length < MAX && seen[h]) sel.push(snap(seen[h]));
    save(); render();
    if (dlg.open) { if (sel.length < 2) dlg.close(); else fill(); }
  }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ax-cmp]'); if (t) { toggle(t.dataset.axCmp); return; }
    var r = e.target.closest('[data-ax-cmp-rm]'); if (r) { toggle(r.dataset.axCmpRm); return; }
    if (e.target.closest('[data-ax-cmp-clear]')) { sel = []; save(); render(); if (dlg.open) dlg.close(); return; }
    if (e.target.closest('[data-ax-cmp-go]')) { fill(); if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); } return; }
    if (e.target.closest('[data-ax-cmp-close]') || e.target === dlg) { dlg.close(); return; }
    var q = e.target.closest('[data-ax-cmp-quote]');
    if (q) {
      // Add only: a product already in the Quote List is never removed from here
      var h = q.dataset.axCmpQuote, p = seen[h];
      if (p && p.vc > 1) { dlg.close(); if (window.axLibQuote) window.axLibQuote(h); return; }
      var r = window.axLibQuote ? window.axLibQuote(h) : 'none';
      if (r === 'added' || r === 'already') { q.textContent = '✓ In Quote List'; q.disabled = true; }
    }
  });

  /* ---------- Side-by-side table ---------- */
  function partNos(p) {
    var s = p.v.map(function (v) { return v.s; }).filter(Boolean);
    if (!s.length) return p.s ? esc(p.s) : '<span class="ax-cmp__na">On request</span>';
    return esc(s.slice(0, 4).join(', ')) + (s.length > 4 ? ' <small>+' + (s.length - 4) + ' more</small>' : '');
  }
  function options(p) {
    if (p.vc < 2) return 'One option';
    var names = p.v.map(function (v) { return v.t; });
    return '<strong>' + p.vc + ' options</strong><br><small>' + esc(names.slice(0, 8).join(' · ')) + (p.vc > 8 ? ' …' : '') + '</small>';
  }
  function colours(p) {
    var im = p.v.filter(function (v) { return v.i; });
    if (!im.length) return '<span class="ax-cmp__na">—</span>';
    return '<div class="ax-cmp__chips">' + im.slice(0, 12).map(function (v) { return '<img src="' + esc(v.i.replace(/width=\d+/, 'width=80')) + '" alt="' + esc(v.t) + '" title="' + esc(v.t) + '" loading="lazy">'; }).join('') + '</div>' +
      (SWATCH.indexOf(p.h) > -1 ? '<a class="ax-cmp__link" href="/pages/swatches?material=' + esc(p.h) + '">See all colours</a>' : '');
  }
  function fill() {
    var rows = [
      ['', function (p) { return '<div class="ax-cmp__head"><button type="button" class="ax-cmp__x" data-ax-cmp-rm="' + esc(p.h) + '" aria-label="Remove ' + esc(p.t) + '">×</button>' + (p.i ? '<img src="' + esc(p.i) + '" alt="">' : '') + '<a href="' + esc(p.u) + '">' + esc(p.t) + '</a></div>'; }],
      ['Category', function (p) { return esc(p.c); }],
      ['Type', function (p) { return esc(p.types.join(', ')); }],
      ['Part number', partNos],
      ['Options', options],
      ['Colours', colours],
      ['Availability', function (p) { return p.a === false ? '<span class="ax-cmp__na">Ask about availability</span>' : '<span class="ax-cmp__ok">In stock</span>'; }],
      ['About', function (p) { return p.d ? '<div class="ax-cmp__about" tabindex="0"><small>' + esc(p.d) + '</small></div>' : '<span class="ax-cmp__na">—</span>'; }],
      ['', function (p) { return '<div class="ax-cmp__acts">' + (seen[p.h] ? (p.vc < 2 && window.axLibInList && window.axLibInList(p.h) ? '<button type="button" class="button" disabled>✓ In Quote List</button>' : '<button type="button" class="button" data-ax-cmp-quote="' + esc(p.h) + '">' + (p.vc > 1 ? 'Choose &amp; add to quote' : 'Add to Quote List') + '</button>') : '') + '<a class="ax-cmp__link" href="' + esc(p.u) + '">View product</a></div>'; }]
    ];
    var h = '<colgroup><col class="ax-cmp__lab">' + sel.map(function () { return '<col>'; }).join('') + '</colgroup><tbody>';
    rows.forEach(function (r) {
      h += '<tr' + (r === rows[0] ? ' class="ax-cmp__items"' : '') + '><th scope="row">' + r[0] + '</th>' + sel.map(function (p) { return '<td>' + r[1](p) + '</td>'; }).join('') + '</tr>';
    });
    table.innerHTML = h + '</tbody>';
  }
  render();
})();
